// removed by extract-text-webpack-plugin
module.exports = {"contentCarousel":"_3l3_vnZlaCZ7iy2JXFLknn","detailBlock":"dSF31AIWCgfiaicNp92kg","title":"H2y0xnwRF23lF-K-qRcI-","content":"_1yX4hb0rwrLZaocblYYiQR","chtDetailBlock":"_2T0BxCeyrEPPP1Oe5mfJC_","img":"_3cMXTdXLJuRc2mhXJal8ky"};


//////////////////
// WEBPACK FOOTER
// ./src/components/content-carousel/ContentCarousel.css
// module id = 379
// module chunks = 0